import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import firebase from 'firebase';
import slugify from 'slugify';
import { db, analytics } from '@/db';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: null,
    welcomeDialog: false,
    animojis: [
      'octopus',
      'dog',
      'dragon',
      'mouse',
      'giraffe',
      'alien',
      'bear',
      'shark',
      'fox',
      'tiger',
      'monkey',
      'rabbit',
      'dino',
      'ghost',
      'owl',
      'panda',
      'koala',
      'robot',
      'unicorn',
      'cat',
      'lion',
    ],
  },
  getters: {
    auth(state) {
      return state.auth;
    },
    welcomeDialog(state) {
      return state.welcomeDialog;
    },
  },
  mutations: {
    SET_AUTH(state, data) {
      state.auth = data;
    },
    SET_WELCOME_DIALOG(state, data) {
      state.welcomeDialog = data;
    },
  },
  actions: {
    setWelcomeDialog({ commit }, show) {
      commit('SET_WELCOME_DIALOG', show);
    },
    fetchAuth({ commit }, auth) {
      if (auth) {
        commit('SET_AUTH', auth);
      } else {
        commit('SET_AUTH', null);
      }
    },
    // eslint-disable-next-line object-curly-newline
    signUp({ commit }, { email, password, school, name }) {
      const languageCode = window.navigator.userLanguage || window.navigator.language;
      return firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          (user) => {
            db.collection('users')
              .doc(email)
              .set({
                email,
                name,
                lang: languageCode.startsWith('sk') ? 'sk' : 'cs',
                uid: user.user.uid,
                school,
                created: new Date(),
              });
            commit('SET_AUTH', user);
          },
        );
    },
    logIn({ commit }, { email, password }) {
      return firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          (user) => {
            commit('SET_AUTH', user);
          },
        );
    },
    signOut({ commit }) {
      commit('SET_AUTH', null);
      return firebase.auth()
        .signOut();
    },
    // eslint-disable-next-line no-empty-pattern
    updateDb({}, {
      type = 'lessons', id, item, value,
    }) {
      return db.collection(type)
        .doc(id)
        .update({
          [item]: value,
        });
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    async uploadFile({ }, { file, lesson, currentMedia, userId, errorCallback }) {
      const fileName = `ucime-se/${userId}/${lesson}/${slugify(file.name)}`;

      const { data } = await axios({
        url: 'https://us-central1-ucime-se.cloudfunctions.net/fileUpload',
        method: 'POST',
        data: {
          fileName,
          fileType: file.type,
        },
      }).catch((error) => {
        errorCallback(error);
      });

      const body = new FormData();
      body.append('acl', data.acl);
      body.append('Content-Type', data['Content-Type']);

      // eslint-disable-next-line
      for (var name in data.fields) {
        body.append(name, data.fields[name]);
      }
      body.append('file', file);

      await axios.post(data.url, body).catch((error) => {
        errorCallback(error);
      });

      const link = `${data.url}/${data.fields.key}`;

      return db.collection('lessons').doc(lesson).update({
        'media.files': [...currentMedia.files, { name: file.name, link }],
      }).then(() => link);
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    logEvent({ }, { name }) {
      // eslint-disable-next-line
      return analytics.logEvent(name);
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    removeFile({ }, { lesson, currentMedia, filename }) {
      // eslint-disable-next-line
      return db.collection('lessons').doc(lesson).update({ 'media.files': currentMedia.files.filter(media => media.name !== filename) });
      // return storage.child(`${email}/${filename}`).delete().then(() => {
      //   // eslint-disable-next-line
      // });
    },
    // eslint-disable-next-line no-empty-pattern
    addToDb({ }, {
      type = 'lessons', value,
    }) {
      return db.collection(type).add(value);
    },
    // eslint-disable-next-line no-empty-pattern
    deleteFromDb({ }, {
      type = 'lessons', id,
    }) {
      return db.collection(type).doc(id).delete();
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    viewerUpdate({ }, { viewer, value, action, lesson }) {
      return axios.post('https://us-central1-ucime-se.cloudfunctions.net/viewerUpdate', {
        action,
        value,
        lesson,
        viewer,
      });
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    viewerCreate({}, { lesson }) {
      return axios.post('https://us-central1-ucime-se.cloudfunctions.net/viewerCreate', {
        lesson,
      });
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    statusChange({ }, { email, lesson, value }) {
      return axios.post('https://us-central1-ucime-se.cloudfunctions.net/statusChange', {
        email,
        lesson,
        value,
      });
    },
    // eslint-disable-next-line no-empty-pattern,object-curly-newline
    rateLesson({ }, { email, lesson, data }) {
      return axios.post('https://us-central1-ucime-se.cloudfunctions.net/lessonRate', {
        email,
        lesson,
        data,
      });
    },
  },
});
